import { Switch } from "@mui/material";

const UpcomingShiftsToggle = ({ checked, onChange }) => {
  return (
    <div className="upcoming-shifts-toggle flex items-center justify-end gap-2 mt-4">
      <span className="text-base font-medium text-black">
        Upcoming Shifts
      </span>

      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        color="default"
      />
    </div>
  );
};

export { UpcomingShiftsToggle };
